<template>
  <div class="edit-riseupgoal-amount-popup">
    <popup :buttons="buttonOptions"
           :closeAction="close">
      <template v-slot:title>
        <span>יעד riseup</span>
      </template>
      <template v-slot:content>
        <span>הסכום שתגדירו הוא הכסף</span>
        <span class="bold">שצפוי להשאר בסוף החודש</span>
        <span>אם תעמדו בהוצאות המשתנות.</span>
        <edit-amount-input :updated-amount="updatedAmount" :onInput="onInput"/>
        <div class="error-container">
          <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
        </div>
        <expense-progress :recommended-or-expected-amount="totalAmount"
                          :recommended-or-expected-label="`${totalVariable} ₪`"
                          :up-to-now-label="`${upToNow} ₪`"
                          :up-to-now-amount="updatedAmount"
                          :pending="true"/>
        <div class="progress-titles">
          <span class="cashflow-type-color">יעד riseup</span>
          <span>יתרת הוצאות משתנות</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import ExpenseProgress from '../../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Segment from '../../../../../../../../../../Segment';
import moneyUtils from '../../../../../../../../../../utils/money';

export default {
  name: 'EditRiseupGoalAmount',
  components: {
    Popup: BaseUI.Popup,
    EditAmountInput: BaseUI.EditAmountInput,
    ExpenseProgress,
  },
  data() {
    return {
      updatedAmount: null,
      errorMsg: '',
    };
  },
  created() {
    Segment.trackUserInteraction('EditRisepGoalAmount_Shown');
    this.updatedAmount = _.round(this.riseupGoal);
  },
  computed: {
    ...mapGetters('cashflowView', ['riseupGoal', 'remainingVariables', 'budgetDate']),
    buttonOptions() {
      return [{
        title: 'עדכון יעד riseup',
        action: () => this.onSave(),
        variant: 'warning',
      }];
    },
    totalAmount() {
      return _.max([this.remainingVariables, 0]) + this.riseupGoal;
    },
    totalVariable() {
      return moneyUtils.formatAmount(Math.ceil(this.totalAmount - this.updatedAmount));
    },
    upToNow() {
      return moneyUtils.formatAmountWithFraction(this.updatedAmount);
    },
    ERROR_MESSAGES() {
      return {
        LESS_THAN_ACTUAL_SUM: 'הסכום צריך להיות נמוך מיתרת ההוצאות המשתנות',
      };
    },
  },
  methods: {
    ...mapActions('editCashflow', ['updateRiseupGoal']),
    close() {
      Segment.trackUserInteraction('EditRisepGoalAmount_CloseClicked');
      this.$emit('close');
    },
    onSave() {
      if (!this.errorMsg) {
        Segment.trackUserInteraction('EditRisepGoalAmount_SaveClicked');
        this.updateRiseupGoal({ budgetDate: this.budgetDate, previousAmount: this.riseupGoal, amount: this.updatedAmount });
        this.close();
      }
    },
    onInput(value) {
      if (value > this.totalAmount) {
        this.errorMsg = this.ERROR_MESSAGES.LESS_THAN_ACTUAL_SUM;
      } else {
        this.errorMsg = '';
        this.updatedAmount = value;
      }
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .edit-riseupgoal-amount-popup {

    .bold {
      font-weight: bold;
    }

    .content {
      line-height: 1.4;
    }

    .cashflow-type-color {
      color: $riseup_mustard;
    }

    .cashflow-type-background-color {
      background-color: $riseup_mustard;
    }

    .edit-amount-input {
      padding: 26px 0px 0px 0px;
    }

    .error-container {
      padding-bottom: 26px;
      position: relative;

      .error-message {
        position: absolute;
        top: -6px;
        color: $riseup_coral;
        font-size: 10px;
        font-family: SimplerPro;
        font-weight: bold;
      }
    }

    .expense-progress-bar-container {
      margin-bottom: 0px;

      .progress-bar-numbers {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 12px;

        .up-to-now {
          .name.pending {
            color: $riseup_mustard;
          }
          .amount .spacer {
            display: none;
          }
        }

        .recommended.pending {
          color: $riseup_black;

          .amount .spacer {
            display: none;
          }
        }
      }

      .progress-bar-illustration {
        height: 6px;
      }
    }

    .progress-titles {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 10px;
      font-weight: bold;
      padding-top: 8px
    }

    .riseup-button {
      margin: 16px 0px;
    }
  }

</style>
